import { Box } from "@mui/material";
import { useTranslation } from "next-i18next";
import { IconShieldWithCheckmark } from "src/components/icons-mui/shield-with-checkmark";
import { Typography } from "src/components-mui/base/typography/typography";

export const CBHeader = () => {
    const { t } = useTranslation("wf-detail");

    return (
        <Box
            sx={{
                py: 2,
                px: 2,
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "blue.100",
            }}
        >
            <Typography
                component="h3"
                sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                }}
            >
                {t("headlines.wikifolio-certificate")}
            </Typography>
            <IconShieldWithCheckmark fontSize="small" sx={{ ml: 1, color: "blue.700" }} aria-hidden="true" />
        </Box>
    );
};
